export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_BOOKINGS_REQUEST = "FETCH_BOOKINGS_REQUEST";
export const UPDATE_CHECKED_BOOKING_REQUEST = "UPDATE_CHECKED_BOOKING_REQUEST";
export const UPDATE_CANCEL_BOOKING_REQUEST = "UPDATE_CANCEL_BOOKING_REQUEST";
